import { useState } from "react";
import { Modal, Button } from "react-bootstrap";

// PASO 1 del split de D.2 "Compra de activo": confirmar que un CapEx planificado ya fue pagado.
// Modal chico de confirmación (no escribe DB por sí mismo): delega la acción en onConfirm (el
// handler del padre, que hace actualizarActivo → cargarDatosFuturos → toast → cerrar). No toca
// fecha_compra, banco ni caja — solo pasa el activo a 'ejecutado_sin_factura' (fuera de proyección).

const formatFechaLarga = (fechaStr) => {
  if (!fechaStr) return "—";
  const f = fechaStr.includes("T") ? fechaStr.substring(0, 10) : fechaStr;
  const [yyyy, mm, dd] = f.split("-");
  return `${dd}/${mm}/${yyyy}`;
};

const formatMonto = (entry) => {
  const n = Math.abs(Number(entry?.importeEnMoneda || 0));
  const num = n.toLocaleString("es-CL", { maximumFractionDigits: 0 });
  const moneda = entry?.moneda_origen === "USD" ? "US$ " : "";
  return `${moneda}${num}`;
};

const ConfirmarCapexPagadoModal = ({ show, onHide, entry, onConfirm }) => {
  const [guardando, setGuardando] = useState(false);

  if (!entry) return null;

  const handleConfirmar = async () => {
    setGuardando(true);
    try {
      // El padre (handleMarcarCapexPagado) hace el write + refetch + toast + cierre del modal.
      await onConfirm(entry);
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1.1rem" }}>Confirmar pago ejecutado</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ fontSize: "0.9rem", lineHeight: 1.7, marginBottom: 16 }}>
          <div>
            <strong>Concepto:</strong> {entry.razon_social_receptor || "—"}
          </div>
          <div>
            <strong>Monto:</strong> {formatMonto(entry)}
          </div>
          <div>
            <strong>Fecha planificada:</strong> {formatFechaLarga(entry.fecha_display)}
          </div>
        </div>

        <div style={{ fontSize: "0.9rem" }}>
          El CapEx sale de la proyección de futuros. ¿Confirmás el pago ejecutado?
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onHide} disabled={guardando}>
          Cancelar
        </Button>
        <Button variant="primary" size="sm" onClick={handleConfirmar} disabled={guardando}>
          {guardando ? "Guardando…" : "Confirmar pago ejecutado"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmarCapexPagadoModal;
